import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "container",
  style: {"width":"100%","height":"100%","overflow-y":"auto","font-size":"8pt"},
  class: "scrollbar-hidden"
}
const _hoisted_2 = ["id", "height", "width"]
const _hoisted_3 = ["fill", "stroke"]
const _hoisted_4 = ["id", "x", "y", "width", "height", "visibility"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoxComponent = _resolveComponent("BoxComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      id: _ctx.container.id,
      ref: "containerSvg",
      class: "designer-container",
      height: _ctx.container.height,
      width: _ctx.container.width,
      style: _normalizeStyle({ transform: `scale(${_ctx.preview ? 1 : 1})`, 'transform-origin': 'top left' })
    }, [
      _createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: 
                    !_ctx.preview && _ctx.container.boxStyle && !_ctx.container.boxStyle.fill
                        ? 'rgba(255, 241, 211, 0.3)'
                        : 'transparent'
                ,
        stroke: !_ctx.preview ? 'whitesmoke' : _ctx.container.boxStyle.stroke,
        "stoke-width": "0.5",
        style: _normalizeStyle({ filter: !_ctx.preview ? 'none' : 'none' })
      }, null, 12, _hoisted_3),
      _createElementVNode("g", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.container.gridCells, (cell) => {
          return (_openBlock(), _createElementBlock("rect", {
            id: cell.id,
            class: "grid-cell",
            key: cell.id,
            x: cell.x,
            y: cell.y,
            width: cell.width,
            height: cell.height,
            stroke: "whitesmoke",
            "stoke-width": "0.5",
            fill: "transparent",
            style: {"border-collapse":"collapse"},
            visibility: _ctx.preview ? 'hidden' : 'visible'
          }, null, 8, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("g", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleBoxes, (box) => {
          return (_openBlock(), _createBlock(_component_BoxComponent, {
            key: box.id,
            box: box,
            preview: _ctx.preview,
            selected: _ctx.isBoxSelected(box),
            selectedBoxObj: _ctx.selectedBoxObj,
            onSelectedBox: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSelectedBox($event))),
            ref_for: true,
            ref: "gridBoxComponent"
          }, null, 8, ["box", "preview", "selected", "selectedBoxObj"]))
        }), 128))
      ])
    ], 12, _hoisted_2))
  ], 512))
}